export default __webpack_public_path__ + "static/media/coin_link.2bfaca8f.svg";